export default __webpack_public_path__ + "static/media/contact_us_in_active.d9116bbc.svg";